<template>
    <div class="address-items">
        <AddressItem
                v-for="(address, index) in store.order.addresses"
                :key="index"
                :address="address"
                :store="store"
                :index="index"
                :Api="Api"

        />
    </div>
</template>
<script>
import AddressItem from './AddressItem';
export default {
    components: {
        AddressItem
    },
    props: ['store', 'Api']
}
</script>
<style lang="scss">
#yacurier-form{
    .address-items{
        display: flex;
        flex-direction: column;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/blocks/FullForm/components/AddressList.vue